// extracted by mini-css-extract-plugin
export default {"root":"unsupported-browser__root","header":"unsupported-browser__header","title":"unsupported-browser__title"};